<template>
         <div>
             <main class="main ">
			<!-- =========== Start of Body ============ -->

			<!-- end of top right mini svg shape -->

			<div class="container">
				<div class="row">
                    
					<div class="col-12 mx-auto   mb-4 mb-lg-5">
                        
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mx-auto">
							<div
								class="form--v10 px-3 py-4 px-md-5 py-md-6 rounded--11 bg-color--light--1"
							>
             <setLevel  />
                            </div>
                        </div>
                    </div>
                    </div>
                        </div>
                    </main>
         </div>
</template>

<script>
import SetLevel from '../components/registrations/SetLevel.vue'

export default {
    
    
    
    
    
    components:
    {
        SetLevel
    }

}
</script>

<style>

</style>